import { render, staticRenderFns } from "./soluution.vue?vue&type=template&id=77aa98d2&scoped=true"
import script from "./soluution.vue?vue&type=script&lang=js"
export * from "./soluution.vue?vue&type=script&lang=js"
import style0 from "./soluution.vue?vue&type=style&index=0&id=77aa98d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa98d2",
  null
  
)

export default component.exports